module.exports = __webpack_public_path__ + "static/media/smile.78173d19.svg";